type TicketPage = {
  tickets: Array<{ id: string }>
  nextPageToken?: string | null
}

// Keep pages accumulated by cursor pagination when Apollo refreshes the base
// query after a remount. Different tabs/page sizes remain separate cache keys;
// a cursor request appends, while a first-page refresh replaces each known row
// with fresh data but preserves older pages that the response cannot contain.
export function mergeTicketPages(
  existing: TicketPage | undefined,
  incoming: TicketPage,
  options: { args?: { pageToken?: string | null } | null }
): TicketPage {
  if (!existing) return incoming

  const append = Boolean(options.args?.pageToken)
  const first = append ? existing.tickets : incoming.tickets
  const second = append ? incoming.tickets : existing.tickets
  const seen = new Set<string>()
  const merged = [] as TicketPage['tickets']
  for (const ticket of [...first, ...second]) {
    if (!seen.has(ticket.id)) {
      seen.add(ticket.id)
      merged.push(ticket)
    }
  }

  return {
    ...incoming,
    // Bound long-lived sessions and the amount copied on each cursor merge.
    // Ticket pages are newest-first. Keep the newly refreshed first page when
    // applying the cap; slice(-500) discarded those rows once a 500-row cache
    // was already populated.
    tickets: merged.slice(0, 500),
    nextPageToken: options.args?.pageToken
      ? incoming.nextPageToken
      : existing.nextPageToken || incoming.nextPageToken
  }
}
